<template>
  <b-modal
    id="report-preview-pdf-modal"
    :title="previewFile.name"
    size="xl"
    hide-footer
    @hidden="$emit('close')"
  >
    <div v-if="isLoading" class="preview-pdf-iframe">
      <LmComponentLoading />
    </div>
    <iframe
      v-else
      :src="previewFile.src"
      frameborder="0"
      width="100%"
      class="preview-pdf-iframe"
    ></iframe>
  </b-modal>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      previewFile: {
        name: '',
        src: ''
      }
    }
  },
  methods: {
    async onPreview () {
      try {
        this.isLoading = true
        await this.$bvModal.show('report-preview-pdf-modal')
        const pdfLocation = await commonsApi.axiosPostWrapper('/reports/preview/', {
          id: this.$route.params.id
        })
        this.previewFile = pdfLocation.data
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.preview-pdf-iframe{
  min-height: 80vh;
}
</style>
